// ==== Universal Code ====
var thisGame;
jQuery(document).on('click', '.games_list a', function () {
  thisGame = jQuery(this).attr('data-target');
  jQuery('.game_block').each(function () {
    jQuery(this).removeClass('active');
  });
  jQuery('#' + thisGame).addClass('active');
  jQuery('body').addClass('gameOpened');
  ArcadeGames.open(thisGame);
});
jQuery(document).on('click', '.closeGame', function () {
  jQuery('body').removeClass('gameOpened');
  jQuery('.game_block').each(function () {
    jQuery(this).removeClass('active');
  });
});

// ==== Arcade rewards: shared login + points-claim handling for every game ====
window.ArcadeRewards = (function () {
  const MIN_SCORE = { carrom: 20, checkers: 10, ludo: 30, scrabble: 15 };
  const POINTS_PER_DOLLAR = { carrom: 100, checkers: 60, ludo: 150, scrabble: 120 };
  const CLAIM_ENDPOINT = '/apps/arcade';//'//technology-architects.com/tasweer-modules/gamingModule/claim.php';
  const STORAGE_KEY = 'arcadePendingClaim';
  const STALE_AFTER_MS = 30 * 60 * 1000;

  let overlay, titleEl, subEl, btnEl;

  function ensureOverlay() {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.id = 'arcade-claim-overlay';
    overlay.innerHTML =
      '<div id="arcade-claim-card">' +
      '<div id="arcade-claim-title"></div>' +
      '<div id="arcade-claim-sub"></div>' +
      '<button id="arcade-claim-btn"></button>' +
      '</div>';
    document.body.appendChild(overlay);
    titleEl = document.getElementById('arcade-claim-title');
    subEl = document.getElementById('arcade-claim-sub');
    btnEl = document.getElementById('arcade-claim-btn');

    const style = document.createElement('style');
    style.textContent =
      '#arcade-claim-overlay{position:fixed;inset:0;background:rgba(0,0,0,.7);display:flex;' +
      'align-items:center;justify-content:center;z-index:9999;padding:20px;}' +
      '#arcade-claim-card{background:#1e1e1e;color:#fff;padding:28px;border-radius:12px;' +
      'max-width:320px;width:100%;text-align:center;display:flex;flex-direction:column;gap:14px;' +
      'font-family:inherit;}' +
      '#arcade-claim-title{font-size:1.3rem;font-weight:bold;}' +
      '#arcade-claim-sub{font-size:.9rem;color:#aaa;}' +
      '#arcade-claim-btn{padding:12px 20px;border:none;border-radius:6px;font-weight:bold;' +
      'cursor:pointer;background:#2e7d32;color:#fff;font-size:1rem;}' +
      '#arcade-claim-btn:disabled{background:#444;color:#888;cursor:not-allowed;}';
    document.head.appendChild(style);
  }

  function show(opts) {
    ensureOverlay();
    titleEl.textContent = opts.title;
    subEl.textContent = opts.sub;
    btnEl.textContent = opts.btnText;
    btnEl.disabled = !!opts.btnDisabled;
    btnEl.onclick = opts.btnAction || null;
    overlay.style.display = 'flex';
  }

  function hide() {
    if (overlay) overlay.style.display = 'none';
  }

  function dollarsFor(game, score) {
    return Math.floor((score / POINTS_PER_DOLLAR[game]) * 100) / 100;
  }

  function startLoginRedirect(pending) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(pending));
    const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
    window.location.href = '/account/login?return_url=' + returnUrl;
  }

  function submitClaim(pending) {
    show({ title: 'Claiming your credit…', sub: 'Just a moment.', btnText: 'Please wait…', btnDisabled: true });

    fetch(CLAIM_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(pending)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('claim failed');
        return res.json();
      })
      .then(function (data) {
        sessionStorage.removeItem(STORAGE_KEY);
        show({
          title: 'Credit added!',
          sub: data && data.amount ? ('$' + data.amount + ' store credit is on your account.') : 'Your store credit is on its way.',
          btnText: 'Keep playing',
          btnAction: hide
        });
      })
      .catch(function () {
        show({
          title: 'Something went wrong',
          sub: 'Your score is saved — try claiming again.',
          btnText: 'Try again',
          btnAction: function () { submitClaim(pending); }
        });
      });
  }

  function reportComplete(gameId, score) {
    const min = MIN_SCORE[gameId] || 0;
    if (typeof score !== 'number' || score < min) return;

    const pending = { game: gameId, score: score, claimedAt: Date.now() };

    if (!window.__arcadeCustomer || !window.__arcadeCustomer.loggedIn) {
      show({
        title: 'You scored ' + score + '!',
        sub: 'Log in to convert it to ~$' + dollarsFor(gameId, score) + ' store credit.',
        btnText: 'Log in to claim',
        btnAction: function () { startLoginRedirect(pending); }
      });
    } else {
      submitClaim(pending);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (!window.__arcadeCustomer || !window.__arcadeCustomer.loggedIn) return;
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return;
    try {
      const pending = JSON.parse(raw);
      if (Date.now() - pending.claimedAt > STALE_AFTER_MS) {
        sessionStorage.removeItem(STORAGE_KEY);
        return;
      }
      submitClaim(pending);
    } catch (e) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  });

  return { reportComplete: reportComplete };
})();

// ==== Lazy game loader — each game's setup only runs the first time it's actually opened ====
window.ArcadeGames = (function () {
  const openers = {};
  const opened = {};

  function register(id, opener) {
    openers[id] = opener;
  }

  function open(id) {
    if (opened[id]) return;
    if (openers[id]) {
      opened[id] = true;
      openers[id]();
    }
  }

  return { register: register, open: open };
})();

// ==== Shared connectivity monitor — one overlay, covers whichever game is open ====
window.ArcadeConnection = (function () {
  const connOverlay = document.getElementById('connection-overlay');
  const connTitle = document.getElementById('connection-title');
  const connSub = document.getElementById('connection-sub');
  const btnResume = document.getElementById('btn-resume');
  let isPaused = false;
  let resumeReady = true;

  function pauseForDisconnect() {
    if (!document.body.classList.contains('gameOpened')) return;
    if (isPaused) return;
    isPaused = true;
    resumeReady = false;
    connTitle.textContent = 'Connection lost';
    connTitle.className = 'connection-title is-offline';
    connSub.textContent = 'Game paused. Reconnect to keep playing.';
    btnResume.textContent = 'Waiting for connection…';
    btnResume.disabled = true;
    connOverlay.style.display = 'flex';
  }

  function markReconnected() {
    if (!isPaused || resumeReady) return;
    resumeReady = true;
    connTitle.textContent = 'Back online';
    connTitle.className = 'connection-title is-back';
    connSub.textContent = 'Ready when you are.';
    btnResume.textContent = 'Resume game';
    btnResume.disabled = false;
  }

  window.resumeAfterReconnect = function () {
    if (!resumeReady) return;
    isPaused = false;
    connOverlay.style.display = 'none';
  };

  async function pingIsOnline() {
    if (location.protocol === 'file:') return navigator.onLine;
    try {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 4000);
      await fetch(location.href, { method: 'HEAD', cache: 'no-store', signal: controller.signal });
      clearTimeout(timeout);
      return true;
    } catch (e) {
      return false;
    }
  }

  async function checkConnection() {
    const online = await pingIsOnline();
    if (!online) pauseForDisconnect();
    else if (isPaused) markReconnected();
  }

  window.addEventListener('offline', pauseForDisconnect);
  window.addEventListener('online', checkConnection);
  setInterval(checkConnection, 5000);
  if (!navigator.onLine) pauseForDisconnect();

  return { isPaused: function () { return isPaused; } };
})();

// ==== Caroom ====
(function () {
  const menuScreen = document.getElementById('menu-screen');
  const gameContainer = document.getElementById('game-container');

  const cCanvas = document.getElementById('carromCanvas');
  const cCtx = cCanvas.getContext('2d');
  const cStatus = document.getElementById('carrom-status');
  const p1ScoreElem = document.getElementById('p1-score');
  const p2ScoreElem = document.getElementById('p2-score');
  const p1Label = document.getElementById('p1-label');
  const p2Label = document.getElementById('p2-label');
  const turnIndicator = document.getElementById('turn-indicator');
  const p1Display = document.getElementById('p1-display');
  const p2Display = document.getElementById('p2-display');
  const carromModal = document.getElementById('carrom-over-modal');

  function reportGameComplete() {
    if (window.ArcadeRewards) ArcadeRewards.reportComplete('carrom', cScores[1]);
  }

  const BOARD_SIZE = 800;
  const FRAME_WIDTH = 50;
  const PLAY_AREA_MIN = FRAME_WIDTH;
  const PLAY_AREA_MAX = BOARD_SIZE - FRAME_WIDTH;
  const PLAY_AREA_SIZE = PLAY_AREA_MAX - PLAY_AREA_MIN;
  const CENTER = BOARD_SIZE / 2;

  const PIECE_RADIUS = 16;
  const POCKET_RADIUS = 22;
  const STRIKER_RADIUS = 24;
  const FRICTION = 0.985;
  const RESTITUTION = 0.92;

  const TYPE_WHITE = 'white';
  const TYPE_BLACK = 'black';
  const TYPE_RED = 'red';
  const TYPE_STRIKER = 'striker';

  const POCKETS = [
    { x: PLAY_AREA_MIN + 25, y: PLAY_AREA_MIN + 25 },
    { x: PLAY_AREA_MAX - 25, y: PLAY_AREA_MIN + 25 },
    { x: PLAY_AREA_MIN + 25, y: PLAY_AREA_MAX - 25 },
    { x: PLAY_AREA_MAX - 25, y: PLAY_AREA_MAX - 25 }
  ];

  let mode = 'classic';
  let cScale = 1;
  let currentPlayer = 1;
  let cScores = { 1: 0, 2: 0 };
  let cGameState = 'AIMING';
  let pendingQueen = false;
  let queenPocketedBy = null;
  let turnPocketedPieces = [];
  let strikerPocketed = false;
  let interactionMode = 'NONE';
  let aimVector = { x: 0, y: 0 };
  let dragStart = { x: 0, y: 0 };
  let pieces = [];
  let striker = null;
  let isVeryFirstShot = true;

  function showMenu() {
    menuScreen.style.display = 'flex';
    gameContainer.style.display = 'none';
  }

  function startGame(selectedMode) {
    menuScreen.style.display = 'none';
    gameContainer.style.display = 'flex';
    mode = selectedMode === 'carrom_color' ? 'color' : 'classic';
    initCarrom(mode);
    resizeCarrom();
  }

  class Piece {
    constructor(x, y, radius, type, tokenNum, pointValue) {
      this.x = x; this.y = y;
      this.vx = 0; this.vy = 0;
      this.radius = radius;
      this.type = type;
      this.tokenNum = tokenNum;
      this.pointValue = pointValue;
      this.isPocketed = false;
      this.mass = radius * radius;
    }

    update() {
      if (this.isPocketed) return;

      this.x += this.vx;
      this.y += this.vy;
      this.vx *= FRICTION;
      this.vy *= FRICTION;

      if (Math.abs(this.vx) < 0.04) this.vx = 0;
      if (Math.abs(this.vy) < 0.04) this.vy = 0;

      const minX = PLAY_AREA_MIN + this.radius;
      const maxX = PLAY_AREA_MAX - this.radius;
      const minY = PLAY_AREA_MIN + this.radius;
      const maxY = PLAY_AREA_MAX - this.radius;

      if (this.x < minX) { this.x = minX; this.vx *= -RESTITUTION; }
      if (this.x > maxX) { this.x = maxX; this.vx *= -RESTITUTION; }
      if (this.y < minY) { this.y = minY; this.vy *= -RESTITUTION; }
      if (this.y > maxY) { this.y = maxY; this.vy *= -RESTITUTION; }
    }

    draw() {
      if (this.isPocketed) return;
      cCtx.save();
      cCtx.beginPath();
      cCtx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);

      let grad = cCtx.createRadialGradient(
        this.x - this.radius * 0.3, this.y - this.radius * 0.3, this.radius * 0.1,
        this.x, this.y, this.radius
      );

      if (this.type === TYPE_WHITE) {
        grad.addColorStop(0, '#ffffff'); grad.addColorStop(1, '#d0c8b0');
        cCtx.fillStyle = grad; cCtx.fill();
        cCtx.strokeStyle = '#8a7d5b'; cCtx.lineWidth = 2; cCtx.stroke();
        cCtx.fillStyle = '#333'; cCtx.font = 'bold 13px sans-serif';
        cCtx.textAlign = 'center'; cCtx.textBaseline = 'middle';
        cCtx.fillText(this.tokenNum, this.x, this.y);
      } else if (this.type === TYPE_BLACK) {
        grad.addColorStop(0, '#555555'); grad.addColorStop(1, '#111111');
        cCtx.fillStyle = grad; cCtx.fill();
        cCtx.strokeStyle = '#000'; cCtx.lineWidth = 1; cCtx.stroke();
        cCtx.fillStyle = '#fff'; cCtx.font = 'bold 13px sans-serif';
        cCtx.textAlign = 'center'; cCtx.textBaseline = 'middle';
        cCtx.fillText(this.tokenNum, this.x, this.y);
      } else if (this.type === TYPE_RED) {
        grad.addColorStop(0, '#ff6b6b'); grad.addColorStop(1, '#b71c1c');
        cCtx.fillStyle = grad; cCtx.fill();
        cCtx.strokeStyle = '#5f0000'; cCtx.lineWidth = 1.5; cCtx.stroke();
        cCtx.fillStyle = '#fff'; cCtx.font = 'bold 12px sans-serif';
        cCtx.textAlign = 'center'; cCtx.textBaseline = 'middle';
        cCtx.fillText(this.tokenNum, this.x, this.y);
      } else if (this.type === TYPE_STRIKER) {
        grad.addColorStop(0, '#ffe082'); grad.addColorStop(1, '#ffb300');
        cCtx.fillStyle = grad; cCtx.fill();
        cCtx.strokeStyle = '#e65100'; cCtx.lineWidth = 2; cCtx.stroke();
        cCtx.beginPath();
        cCtx.arc(this.x, this.y, this.radius * 0.5, 0, Math.PI * 2);
        cCtx.strokeStyle = '#e65100'; cCtx.lineWidth = 1.5; cCtx.stroke();
      }
      cCtx.restore();
    }

    isMoving() {
      return !this.isPocketed && (Math.abs(this.vx) > 0 || Math.abs(this.vy) > 0);
    }
  }

  function initCarrom(gameMode) {
    carromModal.style.display = 'none';
    cScores = { 1: 0, 2: 0 };
    currentPlayer = 1;
    cGameState = 'AIMING';
    pendingQueen = false;
    queenPocketedBy = null;
    pieces = [];
    isVeryFirstShot = true;

    if (gameMode === 'color') {
      p1Label.textContent = "P1 (WHITE)";
      p2Label.textContent = "P2 (BLACK)";
      cStatus.textContent = "P1: White only | P2: Black only | Clear all colored tokens, then pot Queen to win!";
    } else {
      p1Label.textContent = "Player 1";
      p2Label.textContent = "Player 2";
      cStatus.textContent = "Drag striker along baseline, pull back to shoot";
    }

    pieces.push(new Piece(CENTER, CENTER, PIECE_RADIUS, TYPE_RED, "Q", 50));

    let innerRadius = PIECE_RADIUS * 2.05;
    let whiteNums = [1, 2, 3, 4, 5, 6, 7, 8, 9];
    let blackNums = [10, 11, 12, 13, 14, 15, 16, 17, 18];

    for (let i = 0; i < 6; i++) {
      let angle = i * (Math.PI / 3);
      let isWhite = (i % 2 === 0);
      let type = isWhite ? TYPE_WHITE : TYPE_BLACK;
      let num = isWhite ? whiteNums.shift() : blackNums.shift();
      let pts = isWhite ? 10 : 5;
      pieces.push(new Piece(CENTER + Math.cos(angle) * innerRadius, CENTER + Math.sin(angle) * innerRadius, PIECE_RADIUS, type, num, pts));
    }

    let outerRadius = PIECE_RADIUS * 4.1;
    for (let i = 0; i < 12; i++) {
      let angle = i * (Math.PI / 6) + (Math.PI / 12);
      let isWhite = (i % 2 !== 0);
      let type = isWhite ? TYPE_WHITE : TYPE_BLACK;
      let num = isWhite ? whiteNums.shift() : blackNums.shift();
      let pts = isWhite ? 10 : 5;
      pieces.push(new Piece(CENTER + Math.cos(angle) * outerRadius, CENTER + Math.sin(angle) * outerRadius, PIECE_RADIUS, type, num, pts));
    }

    striker = new Piece(0, 0, STRIKER_RADIUS, TYPE_STRIKER, 0, 0);
    resetStrikerPosition();
    updateCarromUI();
  }

  function getBaselineY(player) { return player === 1 ? PLAY_AREA_MAX - 65 : PLAY_AREA_MIN + 65; }
  function clampBaselineX(x) { return Math.max(PLAY_AREA_MIN + 110, Math.min(PLAY_AREA_MAX - 110, x)); }

  function resolveOverlaps(b1, b2) {
    let dx = b2.x - b1.x;
    let dy = b2.y - b1.y;
    let dist = Math.hypot(dx, dy);
    let minDist = b1.radius + b2.radius;

    if (dist < minDist) {
      let nx = dx / (dist || 0.0001);
      let ny = dy / (dist || 0.0001);
      let overlap = minDist - dist;

      let totalMass = b1.mass + b2.mass;
      let ratio1 = b2.mass / totalMass;
      let ratio2 = b1.mass / totalMass;

      b1.x -= nx * overlap * ratio1;
      b1.y -= ny * overlap * ratio1;
      b2.x += nx * overlap * ratio2;
      b2.y += ny * overlap * ratio2;
      return { nx, ny, dist };
    }
    return null;
  }

  function resetStrikerPosition() {
    striker.x = CENTER;
    striker.y = getBaselineY(currentPlayer);
    striker.vx = 0; striker.vy = 0;
    striker.isPocketed = false;
    strikerPocketed = false;

    const activeTokens = pieces.filter(p => !p.isPocketed);
    for (let pass = 0; pass < 5; pass++) {
      activeTokens.forEach(token => resolveOverlaps(striker, token));
    }
  }

  function resizeCarrom() {
    const container = cCanvas.parentElement;
    cCanvas.width = BOARD_SIZE;
    cCanvas.height = BOARD_SIZE;
    cScale = container.clientWidth / BOARD_SIZE;
  }

  function drawCarromBoard() {
    cCtx.fillStyle = '#3a1f0d'; cCtx.fillRect(0, 0, BOARD_SIZE, BOARD_SIZE);
    cCtx.fillStyle = '#5c3214'; cCtx.fillRect(FRAME_WIDTH / 2, FRAME_WIDTH / 2, BOARD_SIZE - FRAME_WIDTH, BOARD_SIZE - FRAME_WIDTH);
    cCtx.fillStyle = '#e6cb9c'; cCtx.fillRect(PLAY_AREA_MIN, PLAY_AREA_MIN, PLAY_AREA_SIZE, PLAY_AREA_SIZE);

    cCtx.strokeStyle = '#2b1608'; cCtx.lineWidth = 4;
    cCtx.strokeRect(PLAY_AREA_MIN, PLAY_AREA_MIN, PLAY_AREA_SIZE, PLAY_AREA_SIZE);

    POCKETS.forEach(p => {
      cCtx.beginPath(); cCtx.arc(p.x, p.y, POCKET_RADIUS, 0, Math.PI * 2);
      cCtx.fillStyle = '#111'; cCtx.fill();
      cCtx.strokeStyle = '#3a1f0d'; cCtx.lineWidth = 3; cCtx.stroke();
    });

    cCtx.beginPath(); cCtx.arc(CENTER, CENTER, PIECE_RADIUS * 1.2, 0, Math.PI * 2);
    cCtx.fillStyle = '#b71c1c'; cCtx.fill();
    cCtx.beginPath(); cCtx.arc(CENTER, CENTER, PIECE_RADIUS * 4.3, 0, Math.PI * 2);
    cCtx.strokeStyle = '#a83232'; cCtx.lineWidth = 2; cCtx.stroke();

    [1, 2].forEach(p => {
      const y = getBaselineY(p);
      const minX = PLAY_AREA_MIN + 110; const maxX = PLAY_AREA_MAX - 110;
      cCtx.strokeStyle = p === currentPlayer ? '#2e7d32' : '#a83232';
      cCtx.lineWidth = p === currentPlayer ? 3 : 2;
      cCtx.beginPath();
      cCtx.moveTo(minX, y - 10); cCtx.lineTo(maxX, y - 10);
      cCtx.moveTo(minX, y + 10); cCtx.lineTo(maxX, y + 10);
      cCtx.stroke();
    });
  }

  function checkCarromCollisions() {
    let all = [...pieces.filter(p => !p.isPocketed)];
    if (!striker.isPocketed) all.push(striker);

    const solverPasses = 8;
    for (let pass = 0; pass < solverPasses; pass++) {
      for (let i = 0; i < all.length; i++) {
        for (let j = i + 1; j < all.length; j++) {
          let b1 = all[i], b2 = all[j];
          let collision = resolveOverlaps(b1, b2);

          if (collision && pass === 0) {
            let nx = collision.nx;
            let ny = collision.ny;
            let tx = -ny;
            let ty = nx;

            let dpTan1 = b1.vx * tx + b1.vy * ty;
            let dpTan2 = b2.vx * tx + b2.vy * ty;

            let dpNorm1 = b1.vx * nx + b1.vy * ny;
            let dpNorm2 = b2.vx * nx + b2.vy * ny;

            if (dpNorm1 - dpNorm2 > 0) {
              let m1 = (dpNorm1 * (b1.mass - b2.mass) + 2.0 * b2.mass * dpNorm2) / (b1.mass + b2.mass);
              let m2 = (dpNorm2 * (b2.mass - b1.mass) + 2.0 * b1.mass * dpNorm1) / (b1.mass + b2.mass);

              b1.vx = (tx * dpTan1 + nx * m1) * RESTITUTION;
              b1.vy = (ty * dpTan1 + ny * m1) * RESTITUTION;
              b2.vx = (tx * dpTan2 + nx * m2) * RESTITUTION;
              b2.vy = (ty * dpTan2 + ny * m2) * RESTITUTION;
            }
          }
        }
      }
    }
  }

  function checkCarromPockets() {
    pieces.filter(p => !p.isPocketed).forEach(b => {
      POCKETS.forEach(p => {
        if (Math.hypot(b.x - p.x, b.y - p.y) < POCKET_RADIUS) {
          b.isPocketed = true; b.vx = 0; b.vy = 0;
          turnPocketedPieces.push(b);
        }
      });
    });

    if (!striker.isPocketed) {
      POCKETS.forEach(p => {
        let dx = striker.x - p.x;
        let dy = striker.y - p.y;
        let dist = Math.hypot(dx, dy);
        let minDist = POCKET_RADIUS + striker.radius;

        if (dist < minDist) {
          let nx = dx / (dist || 1);
          let ny = dy / (dist || 1);

          let overlap = minDist - dist;
          striker.x += nx * overlap;
          striker.y += ny * overlap;

          let dot = striker.vx * nx + striker.vy * ny;
          if (dot < 0) {
            striker.vx = (striker.vx - 2 * dot * nx) * RESTITUTION;
            striker.vy = (striker.vy - 2 * dot * ny) * RESTITUTION;
          }
        }
      });
    }
  }

  function updateCarromPhysics() {
    if (cGameState === 'SHOOTING') {
      let moving = false;

      pieces.forEach(p => {
        p.update();
        if (p.isMoving()) moving = true;
      });

      striker.update();
      if (striker.isMoving()) moving = true;

      checkCarromCollisions();
      checkCarromPockets();

      if (!moving) {
        cGameState = 'EVALUATING';
        evaluateCarromTurn();
      }
    }
  }

  function evaluateCarromTurn() {
    let extraTurn = false;

    if (strikerPocketed) {
      cScores[currentPlayer] = Math.max(0, cScores[currentPlayer] - 10);
      cStatus.textContent = `Foul! Striker pocketed (-10 pts). Turn passes!`;

      let qPocketed = turnPocketedPieces.find(p => p.type === TYPE_RED);
      if (qPocketed) {
        qPocketed.isPocketed = false; qPocketed.x = CENTER; qPocketed.y = CENTER;
      }
    } else {
      let qPocketed = turnPocketedPieces.find(p => p.type === TYPE_RED);
      let stdPocketed = turnPocketedPieces.filter(p => p.type !== TYPE_RED);

      if (mode === 'color') {
        let myTarget = currentPlayer === 1 ? TYPE_WHITE : TYPE_BLACK;
        let otherPlayer = currentPlayer === 1 ? 2 : 1;
        let remainingMyTokens = pieces.filter(p => !p.isPocketed && p.type === myTarget).length;

        stdPocketed.forEach(p => {
          if (p.type === myTarget) {
            cScores[currentPlayer] += 10;
            extraTurn = true;
          } else {
            cScores[otherPlayer] += 10;
          }
        });

        if (qPocketed) {
          if (remainingMyTokens === 0) {
            cScores[currentPlayer] += 50;
            document.getElementById('carrom-winner-msg').textContent = `Game Over!\nPlayer ${currentPlayer} Potted the Queen after clearing colored tokens and Wins!`;
            carromModal.style.display = 'flex';
            cGameState = 'GAME_OVER';
            reportGameComplete(currentPlayer);
            return;
          } else {
            qPocketed.isPocketed = false;
            qPocketed.x = CENTER;
            qPocketed.y = CENTER;
            cStatus.textContent = `Queen reset! Complete all your colored tokens before potting Queen.`;
          }
        } else {
          if (stdPocketed.length > 0 && extraTurn) {
            cStatus.textContent = `Player ${currentPlayer} scored! Take another turn.`;
          } else if (turnPocketedPieces.length === 0) {
            cStatus.textContent = `No tokens pocketed.`;
          }
        }

      } else {
        if (stdPocketed.length > 0) {
          cScores[currentPlayer] += stdPocketed.reduce((s, p) => s + p.pointValue, 0);
          extraTurn = true;

          if (isVeryFirstShot) {
            cStatus.textContent = `First shot scored! Token score awarded & extra turn granted!`;
          }
        }

        if (qPocketed) {
          pendingQueen = true; queenPocketedBy = currentPlayer;
          extraTurn = true;
          cStatus.textContent = `Queen pocketed! Must pot another token to cover.`;
        } else if (pendingQueen && queenPocketedBy === currentPlayer && stdPocketed.length === 0) {
          pendingQueen = false; queenPocketedBy = null;
          let q = pieces.find(p => p.type === TYPE_RED);
          if (q) { q.isPocketed = false; q.x = CENTER; q.y = CENTER; }
          cStatus.textContent = `Queen not covered! Returned to center.`;
        } else if (pendingQueen && queenPocketedBy === currentPlayer && stdPocketed.length > 0) {
          pendingQueen = false;
          cScores[currentPlayer] += 50;
          cStatus.textContent = `Queen covered! +50 Points to Player ${currentPlayer}!`;
        }

        if (turnPocketedPieces.length === 0) cStatus.textContent = `No tokens pocketed.`;

        if (pieces.filter(p => !p.isPocketed).length === 0) {
          let winner = "Tie Game!";
          if (cScores[1] > cScores[2]) winner = "Player 1 Wins!";
          else if (cScores[2] > cScores[1]) winner = "Player 2 Wins!";
          document.getElementById('carrom-winner-msg').textContent = `Game Over!\n${winner}`;
          carromModal.style.display = 'flex';
          cGameState = 'GAME_OVER';
          const winnerNum = cScores[1] > cScores[2] ? 1 : (cScores[2] > cScores[1] ? 2 : null);
          reportGameComplete(winnerNum);
          return;
        }
      }
    }

    isVeryFirstShot = false;

    if (!extraTurn || strikerPocketed) {
      currentPlayer = currentPlayer === 1 ? 2 : 1;
    }

    updateCarromUI();
    turnPocketedPieces = [];
    strikerPocketed = false;
    cGameState = 'AIMING';
    resetStrikerPosition();
  }

  function updateCarromUI() {
    p1ScoreElem.textContent = cScores[1];
    p2ScoreElem.textContent = cScores[2];
    if (currentPlayer === 1) {
      turnIndicator.textContent = mode === 'color' ? "Player 1's Turn (White)" : "Player 1's Turn";
      p1Display.classList.add('active-player'); p2Display.classList.remove('active-player');
    } else {
      turnIndicator.textContent = mode === 'color' ? "Player 2's Turn (Black)" : "Player 2's Turn";
      p2Display.classList.add('active-player'); p1Display.classList.remove('active-player');
    }
  }

  function renderCarrom() {
    updateCarromPhysics();

    cCtx.clearRect(0, 0, BOARD_SIZE, BOARD_SIZE);
    drawCarromBoard();

    pieces.forEach(p => p.draw());
    if (striker && !striker.isPocketed) striker.draw();

    if (cGameState === 'AIMING' && interactionMode === 'AIMING' && striker) {
      cCtx.save();
      cCtx.beginPath();
      cCtx.moveTo(striker.x, striker.y);
      cCtx.lineTo(striker.x + aimVector.x, striker.y + aimVector.y);
      cCtx.strokeStyle = '#ff1744';
      cCtx.lineWidth = 5;
      cCtx.setLineDash([10, 6]);
      cCtx.stroke();

      cCtx.beginPath();
      cCtx.arc(striker.x + aimVector.x, striker.y + aimVector.y, 6, 0, Math.PI * 2);
      cCtx.fillStyle = '#ff1744';
      cCtx.fill();
      cCtx.restore();
    }
  }

  function getCarromCoords(e) {
    const rect = cCanvas.getBoundingClientRect();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    return { x: (clientX - rect.left) / cScale, y: (clientY - rect.top) / cScale };
  }

  function moveStrikerTo(targetX) {
    striker.x = clampBaselineX(targetX);
    const activeTokens = pieces.filter(p => !p.isPocketed);
    for (let pass = 0; pass < 5; pass++) {
      activeTokens.forEach(token => resolveOverlaps(striker, token));
    }
  }

  cCanvas.addEventListener('mousedown', e => {
    if (ArcadeConnection.isPaused() || cGameState !== 'AIMING' || !striker) return;
    const coords = getCarromCoords(e);
    if (Math.hypot(coords.x - striker.x, coords.y - striker.y) < STRIKER_RADIUS * 1.8) {
      interactionMode = 'AIMING'; dragStart = { x: striker.x, y: striker.y };
    } else if (Math.abs(coords.y - getBaselineY(currentPlayer)) < 40) {
      interactionMode = 'POSITIONING'; moveStrikerTo(coords.x); dragStart = { x: striker.x, y: striker.y };
    }
  });

  window.addEventListener('mousemove', e => {
    if (ArcadeConnection.isPaused() || cGameState !== 'AIMING' || interactionMode === 'NONE' || !striker) return;
    const coords = getCarromCoords(e);
    if (interactionMode === 'POSITIONING') moveStrikerTo(coords.x);
    else if (interactionMode === 'AIMING') {
      let dx = dragStart.x - coords.x, dy = dragStart.y - coords.y;
      if (currentPlayer === 1 && dy > 0) dy = 0;
      if (currentPlayer === 2 && dy < 0) dy = 0;
      aimVector = { x: dx * 1.5, y: dy * 1.5 };
    }
  });

  window.addEventListener('mouseup', () => {
    if (ArcadeConnection.isPaused() || cGameState !== 'AIMING' || !striker) return;
    if (interactionMode === 'AIMING') {
      let impulse = Math.hypot(aimVector.x, aimVector.y);
      if (impulse > 10) {
        let power = Math.min(impulse * 0.25, 45);
        let angle = Math.atan2(aimVector.y, aimVector.x);
        striker.vx = Math.cos(angle) * power;
        striker.vy = Math.sin(angle) * power;
        cGameState = 'SHOOTING';
        cStatus.textContent = 'Shot taken!';
      }
    }
    interactionMode = 'NONE'; aimVector = { x: 0, y: 0 };
  });

  cCanvas.addEventListener('touchstart', e => {
    if (ArcadeConnection.isPaused() || cGameState !== 'AIMING' || !striker) return;
    const coords = getCarromCoords(e);
    if (Math.hypot(coords.x - striker.x, coords.y - striker.y) < STRIKER_RADIUS * 1.8) {
      interactionMode = 'AIMING'; dragStart = { x: striker.x, y: striker.y };
    } else if (Math.abs(coords.y - getBaselineY(currentPlayer)) < 40) {
      interactionMode = 'POSITIONING'; moveStrikerTo(coords.x); dragStart = { x: striker.x, y: striker.y };
    }
  }, { passive: true });

  window.addEventListener('touchmove', e => {
    if (ArcadeConnection.isPaused() || cGameState !== 'AIMING' || interactionMode === 'NONE' || !striker) return;
    const coords = getCarromCoords(e);
    if (interactionMode === 'POSITIONING') moveStrikerTo(coords.x);
    else if (interactionMode === 'AIMING') {
      let dx = dragStart.x - coords.x, dy = dragStart.y - coords.y;
      if (currentPlayer === 1 && dy > 0) dy = 0;
      if (currentPlayer === 2 && dy < 0) dy = 0;
      aimVector = { x: dx * 1.5, y: dy * 1.5 };
    }
  }, { passive: true });

  window.addEventListener('touchend', () => {
    if (ArcadeConnection.isPaused() || cGameState !== 'AIMING' || !striker) return;
    if (interactionMode === 'AIMING') {
      let impulse = Math.hypot(aimVector.x, aimVector.y);
      if (impulse > 10) {
        let power = Math.min(impulse * 0.25, 45);
        let angle = Math.atan2(aimVector.y, aimVector.x);
        striker.vx = Math.cos(angle) * power;
        striker.vy = Math.sin(angle) * power;
        cGameState = 'SHOOTING';
        cStatus.textContent = 'Shot taken!';
      }
    }
    interactionMode = 'NONE'; aimVector = { x: 0, y: 0 };
  });

  window.addEventListener('resize', () => {
    if (gameContainer.style.display !== 'none') resizeCarrom();
  });

  function mainLoop() {
    if (gameContainer.style.display !== 'none' && !ArcadeConnection.isPaused()) {
      renderCarrom();
    }
    requestAnimationFrame(mainLoop);
  }

  window.showMenu = showMenu;
  window.startGame = startGame;
  window.initCarrom = initCarrom;

  ArcadeGames.register('g_caroom', function () {
    requestAnimationFrame(mainLoop);
  });
})();
//-- Caroom Ends

// ==== Checkers ====
(function () {
  const ball_SIZE = 8;
  const BLACK = 'black'; // Bottom player (moves UP) — treated as "the customer," matching Carrom's Player 1 convention
  const RED = 'red';     // Top player (moves DOWN)

  let boardState = [];
  let chPlayer = BLACK;
  let selectedPiece = null;
  let validMoves = [];
  let isChainJumping = false;
  let checkersScore = 0;

  const boardElem = document.getElementById('board');
  const turnText = document.getElementById('turn-text');
  const turnBadge = document.getElementById('turn-badge');
  const blackScoreElem = document.getElementById('black-score');
  const redScoreElem = document.getElementById('red-score');
  const resetBtn = document.getElementById('reset-btn');

  const gameOverModal = document.getElementById('game-over-modal');
  const modalWinnerTitle = document.getElementById('modal-winner-title');
  const modalRestartBtn = document.getElementById('modal-restart-btn');

  function initGame() {
    boardState = Array(ball_SIZE).fill(null).map(() => Array(ball_SIZE).fill(null));
    chPlayer = BLACK;
    selectedPiece = null;
    validMoves = [];
    isChainJumping = false;
    checkersScore = 0;
    gameOverModal.classList.remove('active');

    for (let r = 0; r < ball_SIZE; r++) {
      for (let c = 0; c < ball_SIZE; c++) {
        if ((r + c) % 2 === 1) {
          if (r < 3) boardState[r][c] = { player: RED, isKing: false };
          else if (r > 4) boardState[r][c] = { player: BLACK, isKing: false };
        }
      }
    }

    renderBoard();
    updateStatus();
  }

  function renderBoard() {
    boardElem.innerHTML = '';
    const allCaptures = getAllCaptures(chPlayer);

    for (let r = 0; r < ball_SIZE; r++) {
      for (let c = 0; c < ball_SIZE; c++) {
        const square = document.createElement('div');
        square.className = `square ${(r + c) % 2 === 1 ? 'dark' : 'light'}`;
        square.dataset.row = r;
        square.dataset.col = c;

        if (selectedPiece && selectedPiece.r === r && selectedPiece.c === c) {
          square.classList.add('highlight');
        }

        const move = validMoves.find(m => m.toR === r && m.toC === c);
        if (move) {
          square.classList.add('valid-target');
          square.addEventListener('click', () => executeCheckersMove(move));
        }

        const pieceData = boardState[r][c];
        if (pieceData) {
          const piece = document.createElement('div');
          piece.className = `piece ${pieceData.player} ${pieceData.isKing ? 'king' : ''}`;

          piece.addEventListener('click', (e) => {
            e.stopPropagation();
            onPieceClick(r, c, allCaptures);
          });

          square.appendChild(piece);
        }

        boardElem.appendChild(square);
      }
    }
  }

  function onPieceClick(r, c, allCaptures) {
    if (ArcadeConnection.isPaused()) return;
    if (isChainJumping) return;

    const piece = boardState[r][c];
    if (!piece || piece.player !== chPlayer) return;

    if (allCaptures.length > 0) {
      const pieceCaptures = allCaptures.filter(m => m.fromR === r && m.fromC === c);
      if (pieceCaptures.length === 0) return;
      validMoves = pieceCaptures;
    } else {
      validMoves = getSimpleMoves(r, c);
    }

    selectedPiece = { r, c };
    renderBoard();
  }

  function getSimpleMoves(r, c) {
    const piece = boardState[r][c];
    if (!piece) return [];
    const moves = [];
    const dirs = getDirections(piece);

    for (const [dr, dc] of dirs) {
      const nr = r + dr;
      const nc = c + dc;
      if (isInBounds(nr, nc) && !boardState[nr][nc]) {
        moves.push({ fromR: r, fromC: c, toR: nr, toC: nc, capture: null });
      }
    }
    return moves;
  }

  function getCapturesForPiece(r, c) {
    const piece = boardState[r][c];
    if (!piece) return [];
    const captures = [];
    const dirs = getDirections(piece);

    for (const [dr, dc] of dirs) {
      const midR = r + dr;
      const midC = c + dc;
      const targetR = r + (dr * 2);
      const targetC = c + (dc * 2);

      if (isInBounds(targetR, targetC)) {
        const midPiece = boardState[midR][midC];
        const targetSquare = boardState[targetR][targetC];

        if (midPiece && midPiece.player !== piece.player && !targetSquare) {
          captures.push({
            fromR: r, fromC: c,
            toR: targetR, toC: targetC,
            capture: { r: midR, c: midC }
          });
        }
      }
    }
    return captures;
  }

  function getAllCaptures(player) {
    let captures = [];
    for (let r = 0; r < ball_SIZE; r++) {
      for (let c = 0; c < ball_SIZE; c++) {
        if (boardState[r][c] && boardState[r][c].player === player) {
          captures.push(...getCapturesForPiece(r, c));
        }
      }
    }
    return captures;
  }

  function getDirections(piece) {
    if (piece.isKing) return [[-1, -1], [-1, 1], [1, -1], [1, 1]];
    return piece.player === BLACK ? [[-1, -1], [-1, 1]] : [[1, -1], [1, 1]];
  }

  function isInBounds(r, c) {
    return r >= 0 && r < ball_SIZE && c >= 0 && c < ball_SIZE;
  }

  function executeCheckersMove(move) {
    if (ArcadeConnection.isPaused()) return;
    const { fromR, fromC, toR, toC, capture } = move;
    const piece = boardState[fromR][fromC];

    const fromSquare = getSquareElem(fromR, fromC);
    const pieceElem = fromSquare.querySelector('.piece');

    const deltaX = (toC - fromC) * fromSquare.clientWidth;
    const deltaY = (toR - fromR) * fromSquare.clientHeight;

    pieceElem.style.transform = `translate(${deltaX}px, ${deltaY}px)`;

    if (capture && piece.player === BLACK) checkersScore += 10;

    pieceElem.addEventListener('transitionend', () => {
      boardState[toR][toC] = piece;
      boardState[fromR][fromC] = null;

      let newlyKinged = false;
      if (!piece.isKing) {
        if ((piece.player === BLACK && toR === 0) || (piece.player === RED && toR === ball_SIZE - 1)) {
          piece.isKing = true;
          newlyKinged = true;
        }
      }

      if (capture) {
        const capSquare = getSquareElem(capture.r, capture.c);
        const capPiece = capSquare.querySelector('.piece');
        if (capPiece) capPiece.classList.add('capturing');

        setTimeout(() => {
          boardState[capture.r][capture.c] = null;
          continueMoveLogic();
        }, 200);
      } else {
        continueMoveLogic();
      }

      function continueMoveLogic() {
        if (capture && !newlyKinged) {
          const furtherCaptures = getCapturesForPiece(toR, toC);
          if (furtherCaptures.length > 0) {
            selectedPiece = { r: toR, c: toC };
            validMoves = furtherCaptures;
            isChainJumping = true;
            renderBoard();
            return;
          }
        }

        isChainJumping = false;
        selectedPiece = null;
        validMoves = [];
        chPlayer = chPlayer === BLACK ? RED : BLACK;

        renderBoard();
        updateStatus();
        checkGameOver();
      }
    }, { once: true });
  }

  function getSquareElem(r, c) {
    return boardElem.children[r * ball_SIZE + c];
  }

  function updateStatus() {
    let blackCount = 0;
    let redCount = 0;

    for (let r = 0; r < ball_SIZE; r++) {
      for (let c = 0; c < ball_SIZE; c++) {
        if (boardState[r][c]?.player === BLACK) blackCount++;
        if (boardState[r][c]?.player === RED) redCount++;
      }
    }

    blackScoreElem.textContent = blackCount;
    redScoreElem.textContent = redCount;

    turnText.textContent = `${chPlayer === BLACK ? "Dark" : "Red"}'s Turn`;
    turnBadge.style.background = chPlayer === BLACK ? 'var(--black-piece)' : 'var(--red-piece)';
  }

  function checkGameOver() {
    const captures = getAllCaptures(chPlayer);
    let validSimpleMoves = [];

    if (captures.length === 0) {
      for (let r = 0; r < ball_SIZE; r++) {
        for (let c = 0; c < ball_SIZE; c++) {
          if (boardState[r][c]?.player === chPlayer) {
            validSimpleMoves.push(...getSimpleMoves(r, c));
          }
        }
      }
    }

    if (captures.length === 0 && validSimpleMoves.length === 0) {
      const winner = chPlayer === BLACK ? 'Red' : 'Dark';
      setTimeout(() => showGameOverModal(winner), 200);
    }
  }

  function showGameOverModal(winner) {
    if (winner === 'Dark') checkersScore += 25; // win bonus, only when Black/"Dark" (the customer) wins
    modalWinnerTitle.textContent = `${winner} Wins! 🎉`;
    gameOverModal.classList.add('active');
    if (window.ArcadeRewards) ArcadeRewards.reportComplete('checkers', checkersScore);
  }

  resetBtn.addEventListener('click', initGame);
  modalRestartBtn.addEventListener('click', initGame);

  ArcadeGames.register('g_chckers', function () {
    initGame();
  });
})();
//-- Checkers Ends

// ==== Luddo ====
(function () {
  const canvas = document.getElementById('ludoCanvas');
  const ctx = canvas.getContext('2d');
  const size = 600;
  const cellSize = size / 15;

  const COLORS = {
    red: '#ef4444',
    green: '#22c55e',
    yellow: '#eab308',
    blue: '#3b82f6',
    dark: '#1e293b',
    light: '#f8fafc',
    gray: '#cbd5e1'
  };

  const PLAYERS = ['red', 'green', 'yellow', 'blue'];
  let gameMode = 'single'; // 'single' or 'vsAI'
  let userHome = 'red';
  let isAiTurn = false;

  let turnIdx = 0;
  let diceValue = 0;
  let hasRolled = false;
  let validTokens = [];

  const trackCoords = [
    [1,6], [2,6], [3,6], [4,6], [5,6],
    [6,5], [6,4], [6,3], [6,2], [6,1], [6,0],
    [7,0], [8,0],
    [8,1], [8,2], [8,3], [8,4], [8,5],
    [9,6], [10,6], [11,6], [12,6], [13,6], [14,6],
    [14,7], [14,8],
    [13,8], [12,8], [11,8], [10,8], [9,8],
    [8,9], [8,10], [8,11], [8,12], [8,13], [8,14],
    [7,14], [6,14],
    [6,13], [6,12], [6,11], [6,10], [6,9],
    [5,8], [4,8], [3,8], [2,8], [1,8], [0,8],
    [0,7], [0,6]
  ];

  const startTrackIdx = { red: 0, green: 13, yellow: 26, blue: 39 };
  const safeTrackIdxs = [0, 8, 13, 21, 26, 34, 39, 47];

  const homeStretches = {
    red: [[1,7],[2,7],[3,7],[4,7],[5,7]],
    green: [[7,1],[7,2],[7,3],[7,4],[7,5]],
    yellow: [[13,7],[12,7],[11,7],[10,7],[9,7]],
    blue: [[7,13],[7,12],[7,11],[7,10],[7,9]]
  };

  const centerHomeSlots = {
    red: [[6.6, 6.8], [7.1, 6.5], [7.1, 7.1], [6.6, 7.4]],
    green: [[7.6, 6.6], [8.1, 6.8], [7.6, 7.1], [8.1, 7.4]],
    yellow: [[7.1, 7.6], [7.6, 7.9], [7.1, 8.2], [7.6, 8.5]],
    blue: [[6.6, 7.6], [6.6, 8.2], [7.1, 7.9], [6.9, 8.4]]
  };

  const yardPos = {
    red: [[2,2], [3,2], [2,3], [3,3]],
    green: [[11,2], [12,2], [11,3], [12,3]],
    yellow: [[11,11], [12,11], [11,12], [12,12]],
    blue: [[2,11], [3,11], [2,12], [3,12]]
  };

  const gameState = {
    red: [{ step: -1 }, { step: -1 }, { step: -1 }, { step: -1 }],
    green: [{ step: -1 }, { step: -1 }, { step: -1 }, { step: -1 }],
    yellow: [{ step: -1 }, { step: -1 }, { step: -1 }, { step: -1 }],
    blue: [{ step: -1 }, { step: -1 }, { step: -1 }, { step: -1 }]
  };

  const scores = { red: 0, green: 0, yellow: 0, blue: 0 };

  const setupModal = document.getElementById('setupModal');
  const modeSelect = document.getElementById('modeSelect');
  const homeGroup = document.getElementById('homeGroup');
  const homeSelect = document.getElementById('homeSelect');
  const startBtn = document.getElementById('startBtn');
  const rsetBtn = document.getElementById('resetBtn');

  modeSelect.onchange = () => {
    homeGroup.style.display = modeSelect.value === 'vsAI' ? 'flex' : 'none';
  };

  startBtn.onclick = () => {
    gameMode = modeSelect.value;
    userHome = homeSelect.value;
    setupModal.style.display = 'none';
    resetGame();
  };

  rsetBtn.onclick = () => {
    setupModal.style.display = 'flex';
  };

  function resetGame() {
    PLAYERS.forEach(p => {
      scores[p] = 0;
      gameState[p].forEach(t => t.step = -1);
    });
    turnIdx = 0;
    hasRolled = false;
    validTokens = [];
    updateScores();
    updateTurnUI();
    drawBoard();
    msgBox.innerText = 'Roll the dice to play!';
    checkAiTurn();
  }

  function updateScores() {
    PLAYERS.forEach(pKey => {
      document.getElementById(`score-${pKey}`).innerText = `${scores[pKey]} pts`;
    });
  }

  function drawBoard() {
    ctx.clearRect(0, 0, size, size);

    ctx.strokeStyle = '#94a3b8';
    ctx.lineWidth = 1;
    for (let r = 0; r < 15; r++) {
      for (let c = 0; c < 15; c++) {
        ctx.strokeRect(c * cellSize, r * cellSize, cellSize, cellSize);
      }
    }

    drawYard(0, 0, COLORS.red, 'red');
    drawYard(9, 0, COLORS.green, 'green');
    drawYard(9, 9, COLORS.yellow, 'yellow');
    drawYard(0, 9, COLORS.blue, 'blue');

    fillCells(homeStretches.red, COLORS.red);
    fillCells(homeStretches.green, COLORS.green);
    fillCells(homeStretches.yellow, COLORS.yellow);
    fillCells(homeStretches.blue, COLORS.blue);

    fillCell(trackCoords[startTrackIdx.red], COLORS.red);
    fillCell(trackCoords[startTrackIdx.green], COLORS.green);
    fillCell(trackCoords[startTrackIdx.yellow], COLORS.yellow);
    fillCell(trackCoords[startTrackIdx.blue], COLORS.blue);

    safeTrackIdxs.forEach(idx => {
      const [c, r] = trackCoords[idx];
      drawStar(c * cellSize + cellSize/2, r * cellSize + cellSize/2, cellSize * 0.3);
    });

    drawCenterHome();
    drawTokens();
  }

  function drawYard(col, row, color, pKey) {
    ctx.fillStyle = color;
    ctx.fillRect(col * cellSize, row * cellSize, 6 * cellSize, 6 * cellSize);

    ctx.fillStyle = '#ffffff';
    ctx.fillRect((col + 1) * cellSize, (row + 1) * cellSize, 4 * cellSize, 4 * cellSize);

    yardPos[pKey].forEach(([c, r]) => {
      ctx.beginPath();
      ctx.arc((c + 0.5) * cellSize, (r + 0.5) * cellSize, cellSize * 0.35, 0, Math.PI * 2);
      ctx.fillStyle = '#f1f5f9';
      ctx.fill();
      ctx.strokeStyle = '#cbd5e1';
      ctx.stroke();
    });
  }

  function fillCell([c, r], color) {
    ctx.fillStyle = color;
    ctx.fillRect(c * cellSize, r * cellSize, cellSize, cellSize);
    ctx.strokeRect(c * cellSize, r * cellSize, cellSize, cellSize);
  }

  function fillCells(coords, color) {
    coords.forEach(coord => fillCell(coord, color));
  }

  function drawStar(cx, cy, radius) {
    ctx.fillStyle = '#64748b';
    ctx.beginPath();
    for (let i = 0; i < 5; i++) {
      ctx.lineTo(Math.cos((18 + i * 72) * Math.PI / 180) * radius + cx,
                 -Math.sin((18 + i * 72) * Math.PI / 180) * radius + cy);
      ctx.lineTo(Math.cos((54 + i * 72) * Math.PI / 180) * (radius / 2) + cx,
                 -Math.sin((54 + i * 72) * Math.PI / 180) * (radius / 2) + cy);
    }
    ctx.closePath();
    ctx.fill();
  }

  function drawCenterHome() {
    const cx = 7.5 * cellSize;
    const cy = 7.5 * cellSize;

    ctx.fillStyle = COLORS.red;
    ctx.beginPath();
    ctx.moveTo(6 * cellSize, 6 * cellSize);
    ctx.lineTo(9 * cellSize, 6 * cellSize);
    ctx.lineTo(cx, cy);
    ctx.fill();

    ctx.fillStyle = COLORS.green;
    ctx.beginPath();
    ctx.moveTo(9 * cellSize, 6 * cellSize);
    ctx.lineTo(9 * cellSize, 9 * cellSize);
    ctx.lineTo(cx, cy);
    ctx.fill();

    ctx.fillStyle = COLORS.yellow;
    ctx.beginPath();
    ctx.moveTo(9 * cellSize, 9 * cellSize);
    ctx.lineTo(6 * cellSize, 9 * cellSize);
    ctx.lineTo(cx, cy);
    ctx.fill();

    ctx.fillStyle = COLORS.blue;
    ctx.beginPath();
    ctx.moveTo(6 * cellSize, 9 * cellSize);
    ctx.lineTo(6 * cellSize, 6 * cellSize);
    ctx.lineTo(cx, cy);
    ctx.fill();
  }

  function getRawTokenCoords(pKey, tokenIdx, step) {
    if (step === -1) {
      const [c, r] = yardPos[pKey][tokenIdx];
      return [(c + 0.5) * cellSize, (r + 0.5) * cellSize];
    }
    if (step >= 0 && step <= 50) {
      const absIdx = (startTrackIdx[pKey] + step) % 52;
      const [c, r] = trackCoords[absIdx];
      return [(c + 0.5) * cellSize, (r + 0.5) * cellSize];
    }
    if (step >= 51 && step <= 55) {
      const homeIdx = step - 51;
      const [c, r] = homeStretches[pKey][homeIdx];
      return [(c + 0.5) * cellSize, (r + 0.5) * cellSize];
    }
    if (step === 56) {
      const [c, r] = centerHomeSlots[pKey][tokenIdx];
      return [c * cellSize, r * cellSize];
    }
  }

  function drawTokens() {
    const cellOccupancy = {};

    PLAYERS.forEach(pKey => {
      gameState[pKey].forEach((tok, idx) => {
        if (tok.step >= 0 && tok.step <= 50) {
          const absIdx = (startTrackIdx[pKey] + tok.step) % 52;
          cellOccupancy[absIdx] = cellOccupancy[absIdx] || [];
          cellOccupancy[absIdx].push({ pKey, idx });
        }
      });
    });

    PLAYERS.forEach(pKey => {
      gameState[pKey].forEach((tok, idx) => {
        let [x, y] = getRawTokenCoords(pKey, idx, tok.step);
        let tokenRadius = cellSize * 0.32;

        if (tok.step >= 0 && tok.step <= 50) {
          const absIdx = (startTrackIdx[pKey] + tok.step) % 52;
          const sharers = cellOccupancy[absIdx];
          if (sharers && sharers.length > 1) {
            tokenRadius = cellSize * 0.22;
            const myIndex = sharers.findIndex(s => s.pKey === pKey && s.idx === idx);
            const offsets = [
              [-cellSize * 0.15, -cellSize * 0.15],
              [cellSize * 0.15, -cellSize * 0.15],
              [-cellSize * 0.15, cellSize * 0.15],
              [cellSize * 0.15, cellSize * 0.15]
            ];
            x += offsets[myIndex % 4][0];
            y += offsets[myIndex % 4][1];
          }
        }

        if (tok.step === 56) {
          tokenRadius = cellSize * 0.22;
        }

        ctx.beginPath();
        ctx.arc(x, y, tokenRadius, 0, Math.PI * 2);
        ctx.fillStyle = COLORS[pKey];
        ctx.fill();
        ctx.lineWidth = 2.5;
        ctx.strokeStyle = '#ffffff';
        ctx.stroke();

        if (tok.step === 56) {
          ctx.fillStyle = '#ffffff';
          ctx.font = 'bold 10px sans-serif';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText('✓', x, y);
        }

        if (validTokens.some(v => v.pKey === pKey && v.idx === idx)) {
          ctx.beginPath();
          ctx.arc(x, y, tokenRadius + 4, 0, Math.PI * 2);
          ctx.strokeStyle = '#ffffff';
          ctx.lineWidth = 2;
          ctx.stroke();
        }
      });
    });
  }

  const rollBtn = document.getElementById('rollBtn');
  const diceCube = document.getElementById('diceCube');
  const pDot = document.getElementById('pDot');
  const pName = document.getElementById('pName');
  const msgBox = document.getElementById('msgBox');

  const diceRotations = {
    1: 'rotateX(0deg) rotateY(0deg)',
    2: 'rotateX(0deg) rotateY(90deg)',
    3: 'rotateX(-90deg) rotateY(0deg)',
    4: 'rotateX(90deg) rotateY(0deg)',
    5: 'rotateX(0deg) rotateY(-90deg)',
    6: 'rotateX(0deg) rotateY(180deg)'
  };

  function updateTurnUI() {
    const pKey = PLAYERS[turnIdx];
    pDot.style.background = COLORS[pKey];
    const isCPU = gameMode === 'vsAI' && pKey !== userHome;
    pName.innerText = `${pKey.toUpperCase()} ${isCPU ? '(CPU)' : 'Player'}`;
  }

  function checkAiTurn() {
    const pKey = PLAYERS[turnIdx];
    if (gameMode === 'vsAI' && pKey !== userHome) {
      isAiTurn = true;
      rollBtn.disabled = true;
      setTimeout(aiRoll, 800);
    } else {
      isAiTurn = false;
      rollBtn.disabled = false;
    }
  }

  rollBtn.onclick = () => {
    if (ArcadeConnection.isPaused()) return;
    if (hasRolled || isAiTurn) return;
    performRoll();
  };

  function performRoll() {
    rollBtn.disabled = true;
    diceValue = Math.floor(Math.random() * 6) + 1;
    diceCube.style.transform = `rotateX(720deg) rotateY(720deg) ${diceRotations[diceValue]}`;
    hasRolled = true;

    setTimeout(evaluateMoves, 600);
  }

  function aiRoll() {
    performRoll();
  }

  function evaluateMoves() {
    const pKey = PLAYERS[turnIdx];
    validTokens = [];

    gameState[pKey].forEach((tok, idx) => {
      if (tok.step === -1 && diceValue === 6) {
        validTokens.push({ pKey, idx });
      } else if (tok.step >= 0 && tok.step + diceValue <= 56) {
        validTokens.push({ pKey, idx });
      }
    });

    if (validTokens.length === 0) {
      msgBox.innerText = `Rolled a ${diceValue}. No valid moves available!`;
      setTimeout(nextLudoTurn, 1200);
    } else {
      msgBox.innerText = `Rolled a ${diceValue}! Choose a token.`;
      drawBoard();

      if (gameMode === 'vsAI' && pKey !== userHome) {
        setTimeout(aiSelectMove, 800);
      }
    }
  }

  function aiSelectMove() {
    const pKey = PLAYERS[turnIdx];
    let chosenToken = validTokens[0];

    for (let item of validTokens) {
      const tok = gameState[pKey][item.idx];

      if (tok.step === -1 && diceValue === 6) {
        chosenToken = item;
        break;
      }

      const targetStep = tok.step + diceValue;
      if (targetStep <= 50) {
        const absIdx = (startTrackIdx[pKey] + targetStep) % 52;
        if (!safeTrackIdxs.includes(absIdx)) {
          let canCapture = false;
          PLAYERS.forEach(opp => {
            if (opp !== pKey) {
              gameState[opp].forEach(oppTok => {
                if (oppTok.step >= 0 && oppTok.step <= 50) {
                  if (((startTrackIdx[opp] + oppTok.step) % 52) === absIdx) {
                    canCapture = true;
                  }
                }
              });
            }
          });
          if (canCapture) {
            chosenToken = item;
            break;
          }
        }
      }

      if (targetStep === 56) {
        chosenToken = item;
        break;
      }
    }

    executeLudoMove(chosenToken.pKey, chosenToken.idx);
  }

  canvas.onclick = (e) => {
    if (ArcadeConnection.isPaused()) return;
    if (!hasRolled || validTokens.length === 0 || isAiTurn) return;

    const rect = canvas.getBoundingClientRect();
    const clickX = (e.clientX - rect.left) * (size / rect.width);
    const clickY = (e.clientY - rect.top) * (size / rect.height);

    for (let item of validTokens) {
      const [tx, ty] = getRawTokenCoords(item.pKey, item.idx, gameState[item.pKey][item.idx].step);
      const dist = Math.hypot(clickX - tx, clickY - ty);

      if (dist <= cellSize * 0.5) {
        executeLudoMove(item.pKey, item.idx);
        break;
      }
    }
  };

  function executeLudoMove(pKey, idx) {
    const tok = gameState[pKey][idx];
    let extraTurn = false;

    if (tok.step === -1 && diceValue === 6) {
      tok.step = 0;
      scores[pKey] += 5;
      extraTurn = true;
    } else if (tok.step >= 0) {
      tok.step += diceValue;
      scores[pKey] += diceValue;

      if (tok.step === 56) {
        scores[pKey] += 50;
        extraTurn = true;
      }

      if (tok.step <= 50) {
        const absIdx = (startTrackIdx[pKey] + tok.step) % 52;
        if (!safeTrackIdxs.includes(absIdx)) {
          PLAYERS.forEach(oppKey => {
            if (oppKey !== pKey) {
              gameState[oppKey].forEach(oppTok => {
                if (oppTok.step >= 0 && oppTok.step <= 50) {
                  const oppAbsIdx = (startTrackIdx[oppKey] + oppTok.step) % 52;
                  if (oppAbsIdx === absIdx) {
                    oppTok.step = -1;
                    scores[pKey] += 20;
                    extraTurn = true;
                    msgBox.innerText = `${pKey.toUpperCase()} captured ${oppKey.toUpperCase()}! (+20 pts)`;
                  }
                }
              });
            }
          });
        }
      }

      if (diceValue === 6) extraTurn = true;
    }

    updateScores();
    validTokens = [];
    drawBoard();

    if (gameState[pKey].every(t => t.step === 56)) {
      scores[pKey] += 100;
      updateScores();
      msgBox.innerText = `🎉 ${pKey.toUpperCase()} WINS WITH ${scores[pKey]} PTS! 🎉`;
      rollBtn.disabled = true;
      if (window.ArcadeRewards && gameMode === 'vsAI' && pKey === userHome) {
        ArcadeRewards.reportComplete('ludo', scores[pKey]);
      }
      return;
    }

    if (extraTurn) {
      hasRolled = false;
      if (!msgBox.innerText.includes('captured')) {
        msgBox.innerText = `Extra turn! Roll again.`;
      }
      checkAiTurn();
    } else {
      nextLudoTurn();
    }
  }

  function nextLudoTurn() {
    validTokens = [];
    hasRolled = false;
    turnIdx = (turnIdx + 1) % 4;
    updateTurnUI();
    msgBox.innerText = 'Roll the dice to play!';
    drawBoard();
    checkAiTurn();
  }

  ArcadeGames.register('g_luddo', function () {
    modeSelect.onchange();
    drawBoard();
  });
})();
//- Luddo Ends

// ==== Scrab ====
(function () {
  const rackEl = document.getElementById('rack');
  if (!rackEl) return;

  const root = rackEl.closest('.game_block') || document;
  const dictionary = new Set();

  const LETTER_DATA = {
    A: { count: 9, score: 1 },
    B: { count: 2, score: 3 },
    C: { count: 2, score: 3 },
    D: { count: 4, score: 2 },
    E: { count: 12, score: 1 },
    F: { count: 2, score: 4 },
    G: { count: 3, score: 2 },
    H: { count: 2, score: 4 },
    I: { count: 9, score: 1 },
    J: { count: 1, score: 8 },
    K: { count: 1, score: 5 },
    L: { count: 4, score: 1 },
    M: { count: 2, score: 3 },
    N: { count: 6, score: 1 },
    O: { count: 8, score: 1 },
    P: { count: 2, score: 3 },
    Q: { count: 1, score: 10 },
    R: { count: 6, score: 1 },
    S: { count: 4, score: 1 },
    T: { count: 6, score: 1 },
    U: { count: 4, score: 1 },
    V: { count: 2, score: 4 },
    W: { count: 2, score: 4 },
    X: { count: 1, score: 8 },
    Y: { count: 2, score: 4 },
    Z: { count: 1, score: 10 },
    ' ': { count: 2, score: 0 }
  };

  const SPECIAL_SQUARES = {
    '0,0': 'TW',
    '0,7': 'TW',
    '0,14': 'TW',
    '7,0': 'TW',
    '7,14': 'TW',
    '14,0': 'TW',
    '14,7': 'TW',
    '14,14': 'TW',

    '1,1': 'DW',
    '2,2': 'DW',
    '3,3': 'DW',
    '4,4': 'DW',
    '10,10': 'DW',
    '11,11': 'DW',
    '12,12': 'DW',
    '13,13': 'DW',

    '1,13': 'DW',
    '2,12': 'DW',
    '3,11': 'DW',
    '4,10': 'DW',
    '10,4': 'DW',
    '11,3': 'DW',
    '12,2': 'DW',
    '13,1': 'DW',

    '1,5': 'TL',
    '1,9': 'TL',
    '5,1': 'TL',
    '5,5': 'TL',
    '5,9': 'TL',
    '5,13': 'TL',
    '9,1': 'TL',
    '9,5': 'TL',
    '9,9': 'TL',
    '9,13': 'TL',
    '13,5': 'TL',
    '13,9': 'TL',

    '0,3': 'DL',
    '0,11': 'DL',
    '2,6': 'DL',
    '2,8': 'DL',
    '3,0': 'DL',
    '3,7': 'DL',
    '3,14': 'DL',
    '6,2': 'DL',
    '6,6': 'DL',
    '6,8': 'DL',
    '6,12': 'DL',
    '7,3': 'DL',
    '7,11': 'DL',
    '8,2': 'DL',
    '8,6': 'DL',
    '8,8': 'DL',
    '8,12': 'DL',
    '11,0': 'DL',
    '11,7': 'DL',
    '11,14': 'DL',
    '12,6': 'DL',
    '12,8': 'DL',
    '14,3': 'DL',
    '14,11': 'DL',

    '7,7': 'STAR'
  };

  let boardState = createEmptyBoard();
  let tileBag = [];

  let players = [
    {
      score: 0,
      rack: []
    },
    {
      score: 0,
      rack: []
    }
  ];

  let currentPlayer = 0;
  let temporaryPlacements = [];
  let isFirstTurn = true;
  let consecutivePasses = 0;
  let isGameOver = false;

  let draggedTileData = null;
  let touchedElement = null;

  function createEmptyBoard() {
    return Array.from(
      { length: 15 },
      () => Array(15).fill(null)
    );
  }

  function getElement(selector) {
    return root.querySelector(selector);
  }

  function getCell(r, c) {
    return root.querySelector(
      `.cell[data-r="${r}"][data-c="${c}"]`
    );
  }

  function loadDictionary() {
    return fetch(
      'https://raw.githubusercontent.com/raun/Scrabble/master/words.txt'
    )
      .then(response => {
        if (!response.ok) {
          throw new Error(
            `Dictionary request failed (${response.status})`
          );
        }

        return response.text();
      })
      .then(text => {
        dictionary.clear();

        text.split(/\r?\n/).forEach(word => {
          const cleanedWord = word.trim().toUpperCase();

          if (cleanedWord) {
            dictionary.add(cleanedWord);
          }
        });

        const playBtn = getElement('#play-btn');
        const checkBtn = getElement('#check-btn');

        if (playBtn) playBtn.disabled = false;
        if (checkBtn) checkBtn.disabled = false;

        clearMessage();
      })
      .catch(error => {
        console.error('Scrabble dictionary error:', error);

        const playBtn = getElement('#play-btn');
        const checkBtn = getElement('#check-btn');

        if (playBtn) playBtn.disabled = true;
        if (checkBtn) checkBtn.disabled = true;

        showMessage(
          'Failed to load dictionary. Please check your internet connection.'
        );
      });
  }

  function initScrabGame() {
    boardState = createEmptyBoard();

    tileBag = [];

    players = [
      {
        score: 0,
        rack: []
      },
      {
        score: 0,
        rack: []
      }
    ];

    currentPlayer = 0;
    temporaryPlacements = [];
    isFirstTurn = true;
    consecutivePasses = 0;
    isGameOver = false;

    draggedTileData = null;
    touchedElement = null;

    createTileBag();
    createBoard();

    const rack = getElement('#rack');

    if (rack) {
      rack.ondragover = allowDrop;
      rack.ondrop = dropToRack;
    }

    fillRack(0);
    fillRack(1);

    renderRack();
    updateUI();
    setControlsEnabled(true);

    const playBtn = getElement('#play-btn');
    const checkBtn = getElement('#check-btn');

    if (dictionary.size > 0) {
      if (playBtn) playBtn.disabled = false;
      if (checkBtn) checkBtn.disabled = false;

      clearMessage();
    } else {
      if (playBtn) playBtn.disabled = true;
      if (checkBtn) checkBtn.disabled = true;

      showMessage('Loading dictionary...');

      loadDictionary();
    }
  }

  function createTileBag() {
    let id = 0;

    Object.keys(LETTER_DATA).forEach(letter => {
      const data = LETTER_DATA[letter];

      for (let i = 0; i < data.count; i++) {
        tileBag.push({
          id: `tile-${id++}`,
          letter,
          score: data.score,
          isBlank: letter === ' '
        });
      }
    });

    shuffle(tileBag);
  }

  function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));

      [array[i], array[j]] = [
        array[j],
        array[i]
      ];
    }
  }

  function createBoard() {
    const boardEl = getElement('#board');

    if (!boardEl) {
      console.error('Scrabble: #board element was not found.');
      return;
    }

    boardEl.innerHTML = '';

    for (let r = 0; r < 15; r++) {
      for (let c = 0; c < 15; c++) {
        const cell = document.createElement('div');
        const key = `${r},${c}`;
        const special = SPECIAL_SQUARES[key] || '';

        cell.className = `cell ${special}`;

        cell.dataset.r = r;
        cell.dataset.c = c;

        if (special === 'STAR') {
          cell.innerText = '★';
        } else if (special) {
          cell.innerText = special;
        }

        cell.ondragover = allowDrop;
        cell.ondrop = dropToCell;

        boardEl.appendChild(cell);
      }
    }
  }

  function fillRack(playerIndex) {
    if (!players[playerIndex]) {
      return;
    }

    while (
      players[playerIndex].rack.length < 7 &&
      tileBag.length > 0
    ) {
      players[playerIndex].rack.push(
        tileBag.pop()
      );
    }
  }

  function renderRack() {
    const rackEl = getElement('#rack');

    if (!rackEl) {
      return;
    }

    rackEl.innerHTML = '';

    const currentRack = players[currentPlayer].rack;

    currentRack.forEach(tile => {
      rackEl.appendChild(
        createTileElement(tile, false)
      );
    });
  }

  function createTileElement(tile, isLocked = false) {
    const element = document.createElement('div');

    element.className = 'tile';

    if (isLocked) {
      element.classList.add('placed');
    }

    element.id = tile.id;
    element.dataset.letter = tile.letter;
    element.dataset.score = tile.score;

    if (!isGameOver && !isLocked) {
      element.draggable = true;

      element.ondragstart = event => {
        event.dataTransfer.setData(
          'text/plain',
          JSON.stringify(tile)
        );
      };

      element.ontouchstart = event => {
        handleTouchStart(
          event,
          tile,
          element
        );
      };

      element.ontouchend = handleTouchEnd;
    } else {
      element.draggable = false;
      element.ondragstart = null;
      element.ontouchstart = null;
      element.ontouchend = null;
    }

    const letter =
      tile.letter === ' '
        ? ''
        : tile.letter;

    const score =
      Number.isFinite(tile.score)
        ? tile.score
        : 0;

    element.innerHTML =
      `${letter}<span class="sub">${score}</span>`;

    return element;
  }

  function handleTouchStart(event, tile, element) {
    if (isGameOver) {
      return;
    }

    draggedTileData = tile;
    touchedElement = element;

    element.classList.add('active-touch');
  }

  function handleTouchEnd(event) {
    if (!draggedTileData) {
      return;
    }

    if (touchedElement) {
      touchedElement.classList.remove(
        'active-touch'
      );
    }

    const touch = event.changedTouches?.[0];

    if (!touch) {
      draggedTileData = null;
      touchedElement = null;
      return;
    }

    const targetElement = document.elementFromPoint(
      touch.clientX,
      touch.clientY
    );

    if (targetElement) {
      const cell = targetElement.closest('.cell');
      const rack = targetElement.closest('.rack');

      if (cell) {
        placeTileInCell(
          cell,
          draggedTileData
        );
      } else if (rack) {
        returnTileToRack(
          draggedTileData
        );
      }
    }

    draggedTileData = null;
    touchedElement = null;
  }

  function allowDrop(event) {
    if (!isGameOver) {
      event.preventDefault();
    }
  }

  function dropToCell(event) {
    if (isGameOver) {
      return;
    }

    event.preventDefault();

    const cell = event.target.closest('.cell');

    if (!cell) {
      return;
    }

    let tileData;

    try {
      tileData = JSON.parse(
        event.dataTransfer.getData('text/plain')
      );
    } catch (error) {
      console.error(
        'Scrabble: Invalid dragged tile data.',
        error
      );
      return;
    }

    if (!tileData || !tileData.id) {
      return;
    }

    placeTileInCell(
      cell,
      tileData
    );
  }

  function placeTileInCell(cell, tileData) {
    if (!cell || !tileData || isGameOver) {
      return;
    }

    const r = Number.parseInt(
      cell.dataset.r,
      10
    );

    const c = Number.parseInt(
      cell.dataset.c,
      10
    );

    if (
      !Number.isInteger(r) ||
      !Number.isInteger(c) ||
      r < 0 ||
      r >= 15 ||
      c < 0 ||
      c >= 15
    ) {
      return;
    }

    if (boardState[r][c] !== null) {
      return;
    }

    const existingPlacementIndex =
      temporaryPlacements.findIndex(
        placement =>
          placement.tile.id === tileData.id
      );

    if (
      tileData.isBlank ||
      tileData.letter === ' '
    ) {
      const assigned = window.prompt(
        'Enter letter for blank tile (A-Z):',
        'A'
      );

      if (
        !assigned ||
        assigned.length !== 1 ||
        !/^[a-z]$/i.test(assigned)
      ) {
        return;
      }

      tileData.letter =
        assigned.toUpperCase();

      // Blank tiles always score zero.
      tileData.score = 0;
    }

    if (existingPlacementIndex !== -1) {
      const oldPlacement =
        temporaryPlacements[
          existingPlacementIndex
        ];

      boardState[
        oldPlacement.r
      ][
        oldPlacement.c
      ] = null;

      const oldCell = getCell(
        oldPlacement.r,
        oldPlacement.c
      );

      if (oldCell) {
        cleanCellDOM(oldCell);
      }

      temporaryPlacements.splice(
        existingPlacementIndex,
        1
      );
    } else {
      players[currentPlayer].rack =
        players[currentPlayer].rack.filter(
          tile =>
            tile.id !== tileData.id
        );

      renderRack();
    }

    boardState[r][c] = tileData;

    temporaryPlacements.push({
      r,
      c,
      tile: tileData
    });

    cell.innerHTML = '';

    const tileElement =
      createTileElement(
        tileData,
        false
      );

    tileElement.classList.add('temp');

    cell.appendChild(tileElement);

    clearMessage();
  }

  function dropToRack(event) {
    if (isGameOver) {
      return;
    }

    event.preventDefault();

    let tileData;

    try {
      tileData = JSON.parse(
        event.dataTransfer.getData('text/plain')
      );
    } catch (error) {
      console.error(
        'Scrabble: Invalid dragged tile data.',
        error
      );
      return;
    }

    if (!tileData || !tileData.id) {
      return;
    }

    returnTileToRack(tileData);
  }

  function returnTileToRack(tileData) {
    if (!tileData || isGameOver) {
      return;
    }

    const index =
      temporaryPlacements.findIndex(
        placement =>
          placement.tile.id === tileData.id
      );

    if (index === -1) {
      return;
    }

    const placement =
      temporaryPlacements[index];

    boardState[
      placement.r
    ][
      placement.c
    ] = null;

    const cell = getCell(
      placement.r,
      placement.c
    );

    if (cell) {
      cleanCellDOM(cell);
    }

    temporaryPlacements.splice(
      index,
      1
    );

    if (tileData.isBlank) {
      tileData.letter = ' ';
      tileData.score = 0;
    }

    players[currentPlayer].rack.push(
      tileData
    );

    renderRack();
  }

  function cleanCellDOM(cell) {
    if (!cell) {
      return;
    }

    cell.innerHTML = '';

    const r = cell.dataset.r;
    const c = cell.dataset.c;

    const special =
      SPECIAL_SQUARES[`${r},${c}`] || '';

    if (special === 'STAR') {
      cell.innerText = '★';
    } else if (special) {
      cell.innerText = special;
    }
  }

  function recallTiles() {
    if (isGameOver) {
      return;
    }

    temporaryPlacements.forEach(
      placement => {
        boardState[
          placement.r
        ][
          placement.c
        ] = null;

        const cell = getCell(
          placement.r,
          placement.c
        );

        if (cell) {
          cleanCellDOM(cell);
        }

        if (placement.tile.isBlank) {
          placement.tile.letter = ' ';
          placement.tile.score = 0;
        }

        players[currentPlayer].rack.push(
          placement.tile
        );
      }
    );

    temporaryPlacements = [];

    renderRack();
    clearMessage();
  }

  function checkCurrentWord() {
    if (isGameOver) {
      return;
    }

    if (temporaryPlacements.length === 0) {
      showMessage(
        'Place tiles on the board first.'
      );
      return;
    }

    const validation =
      validatePlacements(
        temporaryPlacements
      );

    if (validation.valid) {
      const wordList =
        validation.formedWords
          .map(word => word.word)
          .join(' & ');

      showMessage(
        `Valid Move! Formed: [${wordList}] (+${validation.score} pts)`
      );
    } else {
      showMessage(
        `Invalid move: ${validation.reason}`
      );
    }
  }

  function playTurn() {
    if (isGameOver) {
      return;
    }

    if (temporaryPlacements.length === 0) {
      showMessage(
        'Place tiles before playing.'
      );
      return;
    }

    const validation =
      validatePlacements(
        temporaryPlacements
      );

    if (!validation.valid) {
      showMessage(
        validation.reason
      );
      return;
    }

    players[currentPlayer].score +=
      validation.score;

    isFirstTurn = false;
    consecutivePasses = 0;

    commitPlacements(
      temporaryPlacements
    );

    fillRack(currentPlayer);

    temporaryPlacements = [];

    updateUI();

    if (checkEndGameConditions()) {
      return;
    }

    nextTurn();
  }

  function commitPlacements(placements) {
    placements.forEach(placement => {
      const cell = getCell(
        placement.r,
        placement.c
      );

      if (!cell) {
        return;
      }

      cell.innerHTML = '';

      const tileElement =
        createTileElement(
          placement.tile,
          true
        );

      cell.appendChild(
        tileElement
      );
    });
  }

  function checkBoardConnectivity() {
    let totalTiles = 0;
    let startNode = null;

    for (let r = 0; r < 15; r++) {
      for (let c = 0; c < 15; c++) {
        if (boardState[r][c] !== null) {
          totalTiles++;

          if (!startNode) {
            startNode = { r, c };
          }
        }
      }
    }

    if (totalTiles === 0) {
      return true;
    }

    const visited = new Set();
    const queue = [startNode];

    visited.add(
      `${startNode.r},${startNode.c}`
    );

    let count = 0;

    while (queue.length > 0) {
      const current = queue.shift();

      count++;

      const neighbors = [
        {
          r: current.r - 1,
          c: current.c
        },
        {
          r: current.r + 1,
          c: current.c
        },
        {
          r: current.r,
          c: current.c - 1
        },
        {
          r: current.r,
          c: current.c + 1
        }
      ];

      neighbors.forEach(neighbor => {
        const {
          r,
          c
        } = neighbor;

        if (
          r < 0 ||
          r >= 15 ||
          c < 0 ||
          c >= 15
        ) {
          return;
        }

        if (
          boardState[r][c] !== null &&
          !visited.has(`${r},${c}`)
        ) {
          visited.add(`${r},${c}`);
          queue.push(neighbor);
        }
      });
    }

    return count === totalTiles;
  }

  function validatePlacements(placements) {
    if (!placements.length) {
      return {
        valid: false,
        reason: 'No tiles placed.'
      };
    }

    /*
     * First move must cover the center square.
     */
    if (isFirstTurn) {
      const coversCenter =
        placements.some(
          placement =>
            placement.r === 7 &&
            placement.c === 7
        );

      if (!coversCenter) {
        return {
          valid: false,
          reason:
            'First move must cover center star (7,7).'
        };
      }
    }

    /*
     * Multiple tiles in one turn must
     * be placed in the same row or column.
     */
    if (placements.length > 1) {
      const sameRow =
        placements.every(
          placement =>
            placement.r === placements[0].r
        );

      const sameColumn =
        placements.every(
          placement =>
            placement.c === placements[0].c
        );

      if (!sameRow && !sameColumn) {
        return {
          valid: false,
          reason:
            'All tiles played in one turn must be in the same row or column.'
        };
      }

      /*
       * Make sure there are no empty spaces
       * between the played tiles.
       */
      if (sameRow) {
        const minColumn =
          Math.min(
            ...placements.map(
              placement => placement.c
            )
          );

        const maxColumn =
          Math.max(
            ...placements.map(
              placement => placement.c
            )
          );

        for (
          let c = minColumn;
          c <= maxColumn;
          c++
        ) {
          if (
            boardState[
              placements[0].r
            ][c] === null
          ) {
            return {
              valid: false,
              reason:
                'New tiles must be placed consecutively with no gaps.'
            };
          }
        }
      } else {
        const minRow =
          Math.min(
            ...placements.map(
              placement => placement.r
            )
          );

        const maxRow =
          Math.max(
            ...placements.map(
              placement => placement.r
            )
          );

        for (
          let r = minRow;
          r <= maxRow;
          r++
        ) {
          if (
            boardState[r][
              placements[0].c
            ] === null
          ) {
            return {
              valid: false,
              reason:
                'New tiles must be placed consecutively with no gaps.'
            };
          }
        }
      }
    }

    /*
     * All tiles must remain connected.
     */
    if (!checkBoardConnectivity()) {
      return {
        valid: false,
        reason:
          'All tiles must connect to form a single continuous word grid.'
      };
    }

    /*
     * Find all words formed by this move.
     */
    const formedWords =
      scanAllFormedWords(
        placements
      );

    if (formedWords.length === 0) {
      return {
        valid: false,
        reason:
          'No valid multi-letter words created.'
      };
    }

    /*
     * Every newly placed tile must
     * participate in at least one
     * multi-letter word.
     */
    for (const placement of placements) {
      const horizontalWord =
        getFullWordAt(
          placement.r,
          placement.c,
          0,
          1,
          placements
        );

      const verticalWord =
        getFullWordAt(
          placement.r,
          placement.c,
          1,
          0,
          placements
        );

      const horizontalLength =
        horizontalWord
          ? horizontalWord.word.length
          : 0;

      const verticalLength =
        verticalWord
          ? verticalWord.word.length
          : 0;

      if (
        horizontalLength < 2 &&
        verticalLength < 2
      ) {
        return {
          valid: false,
          reason:
            `Tile '${placement.tile.letter}' doesn't form a multi-letter word.`
        };
      }
    }

    /*
     * Check every formed word against
     * the loaded dictionary.
     */
    for (const formedWord of formedWords) {
      if (
        !dictionary.has(
          formedWord.word
        )
      ) {
        return {
          valid: false,
          reason:
            `"${formedWord.word}" is not a valid dictionary word.`
        };
      }
    }

    /*
     * Calculate score.
     */
    let turnScore =
      formedWords.reduce(
        (total, word) =>
          total + word.score,
        0
      );

    /*
     * Bingo bonus.
     */
    if (placements.length === 7) {
      turnScore += 50;
    }

    return {
      valid: true,
      score: turnScore,
      formedWords
    };
  }

  function scanAllFormedWords(placements) {
    const wordMap = new Map();

    placements.forEach(placement => {
      const horizontalWord =
        getFullWordAt(
          placement.r,
          placement.c,
          0,
          1,
          placements
        );

      if (
        horizontalWord &&
        horizontalWord.word.length > 1
      ) {
        const key =
          `H:${horizontalWord.startR},${horizontalWord.startC}-${horizontalWord.word}`;

        wordMap.set(
          key,
          horizontalWord
        );
      }

      const verticalWord =
        getFullWordAt(
          placement.r,
          placement.c,
          1,
          0,
          placements
        );

      if (
        verticalWord &&
        verticalWord.word.length > 1
      ) {
        const key =
          `V:${verticalWord.startR},${verticalWord.startC}-${verticalWord.word}`;

        wordMap.set(
          key,
          verticalWord
        );
      }
    });

    return Array.from(
      wordMap.values()
    );
  }

  function getFullWordAt(
    r,
    c,
    dr,
    dc,
    placements
  ) {
    let startR = r;
    let startC = c;

    /*
     * Find the beginning of the word.
     */
    while (
      startR - dr >= 0 &&
      startR - dr < 15 &&
      startC - dc >= 0 &&
      startC - dc < 15 &&
      boardState[
        startR - dr
      ][
        startC - dc
      ] !== null
    ) {
      startR -= dr;
      startC -= dc;
    }

    let word = '';
    let wordScore = 0;
    let wordMultiplier = 1;
    let containsNewPlacement = false;

    let currentR = startR;
    let currentC = startC;

    /*
     * Read the complete word.
     */
    while (
      currentR >= 0 &&
      currentR < 15 &&
      currentC >= 0 &&
      currentC < 15 &&
      boardState[
        currentR
      ][
        currentC
      ] !== null
    ) {
      const tile =
        boardState[
          currentR
        ][
          currentC
        ];

      let letterScore =
        Number.isFinite(tile.score)
          ? tile.score
          : 0;

      const isNew =
        placements.some(
          placement =>
            placement.r === currentR &&
            placement.c === currentC
        );

      /*
       * Premium squares only apply
       * to newly placed tiles.
       */
      if (isNew) {
        containsNewPlacement = true;

        const special =
          SPECIAL_SQUARES[
            `${currentR},${currentC}`
          ];

        if (special === 'DL') {
          letterScore *= 2;
        }

        if (special === 'TL') {
          letterScore *= 3;
        }

        if (
          special === 'DW' ||
          special === 'STAR'
        ) {
          wordMultiplier *= 2;
        }

        if (special === 'TW') {
          wordMultiplier *= 3;
        }
      }

      word += tile.letter;
      wordScore += letterScore;

      currentR += dr;
      currentC += dc;
    }

    /*
     * Ignore words that weren't created
     * or changed by the current move.
     */
    if (!containsNewPlacement) {
      return null;
    }

    return {
      word,
      score:
        wordScore * wordMultiplier,
      startR,
      startC
    };
  }

  function passTurn() {
    if (isGameOver) {
      return;
    }

    recallTiles();

    consecutivePasses++;

    if (checkEndGameConditions()) {
      return;
    }

    nextTurn();
  }

  function nextTurn() {
    if (isGameOver) {
      return;
    }

    currentPlayer =
      currentPlayer === 0
        ? 1
        : 0;

    renderRack();
    updateUI();
  }

  function setControlsEnabled(enabled) {
    const playBtn =
      getElement('#play-btn');

    const checkBtn =
      getElement('#check-btn');

    const recallBtn =
      getElement('#recall-btn');

    const passBtn =
      getElement('#pass-btn');

    if (playBtn) {
      playBtn.disabled = !enabled;
    }

    if (checkBtn) {
      checkBtn.disabled = !enabled;
    }

    if (recallBtn) {
      recallBtn.disabled = !enabled;
    }

    if (passBtn) {
      passBtn.disabled = !enabled;
    }
  }

  function checkEndGameConditions() {
    const isBagEmpty =
      tileBag.length === 0;

    const playerOneRackEmpty =
      players[0].rack.length === 0;

    const playerTwoRackEmpty =
      players[1].rack.length === 0;

    /*
     * A player has used all remaining tiles.
     */
    if (
      isBagEmpty &&
      (
        playerOneRackEmpty ||
        playerTwoRackEmpty
      )
    ) {
      triggerGameOver(
        'A player played all remaining tiles!'
      );

      return true;
    }

    /*
     * Four consecutive passes
     * with an empty bag.
     */
    if (
      isBagEmpty &&
      consecutivePasses >= 4
    ) {
      triggerGameOver(
        '4 consecutive passes with empty bag - Game Over!'
      );

      return true;
    }

    return false;
  }

  function triggerGameOver(reason) {
    isGameOver = true;

    setControlsEnabled(false);

    updateUI();

    const playerOneScore =
      players[0].score;

    const playerTwoScore =
      players[1].score;

    let winner = "It's a Tie!";

    if (
      playerOneScore >
      playerTwoScore
    ) {
      winner = 'Player 1 Wins! 🎉';
    } else if (
      playerTwoScore >
      playerOneScore
    ) {
      winner = 'Player 2 Wins! 🎉';
    }

    showMessage(
      `GAME OVER: ${reason} | ${winner}`
    );

    const turnIndicator =
      getElement('#turn-indicator');

    if (turnIndicator) {
      turnIndicator.innerText = 'End';
    }

    /*
     * Reward Player 1 only when Player 1 wins.
     */
    if (
      playerOneScore > playerTwoScore &&
      window.ArcadeRewards
    ) {
      window.ArcadeRewards.reportComplete(
        'scrabble',
        playerOneScore
      );
    }
  }

  function showMessage(message) {
    const messageBox =
      getElement('#msg-box');

    if (messageBox) {
      messageBox.innerText = message;
    }
  }

  function clearMessage() {
    const messageBox =
      getElement('#msg-box');

    if (messageBox) {
      messageBox.innerText = '';
    }
  }

  function updateUI() {
    const scoreOne =
      getElement('#score-1');

    const scoreTwo =
      getElement('#score-2');

    const bagCount =
      getElement('#tile-bag-count');

    const turnIndicator =
      getElement('#turn-indicator');

    if (scoreOne) {
      scoreOne.innerText =
        players[0].score;
    }

    if (scoreTwo) {
      scoreTwo.innerText =
        players[1].score;
    }

    if (bagCount) {
      bagCount.innerText =
        tileBag.length;
    }

    if (turnIndicator) {
      turnIndicator.innerText =
        currentPlayer === 0
          ? 'P1'
          : 'P2';
    }
  }

  /*
   * Register the Scrabble game with
   * the common arcade game system.
   */
  if (
    window.ArcadeGames &&
    typeof window.ArcadeGames.register ===
      'function'
  ) {
    window.ArcadeGames.register(
      'g_scrab',
      function () {
        initScrabGame();
      }
    );
  } else {
    /*
     * Fallback if ArcadeGames is loaded
     * after this script.
     */
    window.addEventListener(
      'DOMContentLoaded',
      function () {
        if (
          window.ArcadeGames &&
          typeof window.ArcadeGames.register ===
            'function'
        ) {
          window.ArcadeGames.register(
            'g_scrab',
            function () {
              initScrabGame();
            }
          );
        }
      },
      { once: true }
    );
  }
})();
//- Scrab Ends